import { render, staticRenderFns } from "./XinWenKePage.vue?vue&type=template&id=0fc931ac&scoped=true"
import script from "./XinWenKePage.vue?vue&type=script&lang=js"
export * from "./XinWenKePage.vue?vue&type=script&lang=js"
import style0 from "./XinWenKePage.vue?vue&type=style&index=0&id=0fc931ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc931ac",
  null
  
)

export default component.exports